import _ from 'lodash'
import { isValid } from '../state/slice/form'
import { IMask } from 'react-imask/dist/react-imask'

export const updateFieldObjectAndDisable = (state, path, value) => {
  return updateFieldObject(state, path, value, true)
}

export const updateFieldObject = (state, path, value, disable = false) => {
  if (value === null || value === undefined) {
    return _.get(state, path) || value
  }
  if (typeof value === 'object') {
    if (path.toLowerCase().endsWith('state')) {
      return updateFieldObject(state, path, value.abbreviation, disable)
    } else {
      return Array.isArray(value) ?
        value.map((arrayItem, index) => updateFieldObject(state, `${path}[${index}]`, arrayItem, disable)) :
        Object.keys(value).reduce((obj, subKey) => {
          return subKey in obj ? {
            ...obj,
            [subKey]: updateFieldObject(state, `${path}.${subKey}`, value[subKey], disable)
          } : obj
        }, _.get(state, path))
    }
  } else {
    const rawValue = typeof value === 'number' ? value.toString() : value
    const existingField = _.get(state, path)
    const stateValue = existingField?.maskOptions ? IMask.createMask({
      ...existingField.maskOptions.additionalProps,
      mask: existingField.maskOptions.isNumber ? Number : existingField.maskOptions.pattern
    }).resolve(rawValue) : rawValue
    const newField = {
      ..._.get(state, path),
      value: stateValue,
      dirty: true
    }
    const valid = isValid(newField)
    return {
      ...newField,
      valid: valid,
      disabled: disable ? valid : _.get(state, path).disabled
    }
  }
}
